export default function Footer(){
    return(
        <>
        <footer className="footer bg-black text-white">
           Nurdan Vayni © Copyright 2024
        </footer>
        </>
    );
}